var map = {
	"./review1.jpeg": 4358,
	"./review2.jpg": 3990,
	"./review3.jpeg": 9100,
	"./review4.jpeg": 5097,
	"./review5.jpeg": 3362,
	"./review6.jpeg": 3951,
	"./review7.jpeg": 6360,
	"./reviewDefault.png": 3967
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7477;